import api from "./axios";

const CUSTOMER_AUTH_BASE = "/customer-auth";

export const registerRequest = (customer) =>
  api.post(`${CUSTOMER_AUTH_BASE}/register`, customer);

export const loginRequest = (credentials) =>
  api.post(`${CUSTOMER_AUTH_BASE}/login`, credentials);

export const verifyTokenRequest = () =>
  api.get(`${CUSTOMER_AUTH_BASE}/me`, {
    headers: { "Cache-Control": "no-store" },
  });

export const updateProfileRequest = (profile) =>
  api.patch(`${CUSTOMER_AUTH_BASE}/me`, profile);

export const logoutRequest = () =>
  api.post(`${CUSTOMER_AUTH_BASE}/logout`);
